import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";

import {
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBBtn,
} from "mdbreact";

import "../css/scrollbar.css";

import AccessDenied from "../components/AccessDenied";

import AddEditCustomer from "./AddEditCustomer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";

const Customer = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [rows, setRows] = useState([]);
  const [showPreloader, setPreloader] = useState("normal");

  const [modalAddEdit, showAddEdit] = useState(false);

  const toggleAddEdit = () => {
    showAddEdit(!modalAddEdit);
    loadData();
  };

  const [bRefresh, setRefresh] = useState(false);
  function refreshGrid() {
    setRefresh(!bRefresh);
    loadData();
  }

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }
  function loadData() {
    Axios.get(props.apiServer + "/customerlist", bearer)
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const useMountEffect = (functionName) => useEffect(functionName, []);

  useMountEffect(checkAdminAccess);
  useMountEffect(loadData);
  if (isAdmin == 0) {
    return (
      <React.Fragment>
        <AccessDenied />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {props.quickadd === "yes" ? (
        <MDBRow className="mt-0 pt-0"></MDBRow>
      ) : (
        <MDBRow className="mt-5 pt-5"></MDBRow>
      )}
      <MDBRow>
        <MDBCol md="12">
          {showPreloader === "normal" ? (
            <MDBRow>
              <MDBCol md="4"></MDBCol>
              <MDBCol md="4" className="text-center">
                <br />
                <img
                  src={props.deployURL + "/loading.gif"}
                  style={{ width: "300px", textAlign: "center" }}
                  alt="loading"
                />
                <br />
              </MDBCol>
              <MDBCol md="4"></MDBCol>
            </MDBRow>
          ) : (
            <React.Fragment>
              <MDBRow>
                <MDBCol md="8">
                  <h6
                    style={{ fontFamily: "Montserrat", fontWeight: "400" }}
                    className="display-5 blue-grey-text ml-1"
                  >
                    {" "}
                    Customers
                  </h6>
                </MDBCol>
                <MDBCol md="4">
                  <MDBBtn
                    onClick={toggleAddEdit}
                    className="cloudy-knoxville-gradient brown-text float-right"
                  >
                    <MDBIcon
                      icon="plus"
                      size="1x"
                      className="brown-text"
                      title="Add New Employee"
                    />
                  </MDBBtn>
                </MDBCol>
              </MDBRow>

              <MaterialTable
                title=""
                columns={[
                  { title: "code", field: "code", hidden: true },
                  {
                    title: "Customer",
                    field: "label",
                  },
                  { title: "Deleted", field: "deleted" },
                ]}
                data={rows}
                options={{
                  search: true,
                  actionsColumnIndex: -1,
                }}
                detailPanel={[
                  {
                    icon: () => (
                      <MDBIcon icon="chevron-right" className="cyan-text" />
                    ),
                    openIcon: () => (
                      <MDBIcon
                        icon="chevron-down"
                        size="2x"
                        className="cyan-text"
                      />
                    ),
                    tooltip: "Customer Details",
                    render: (rowData) => {
                      return (
                        <React.Fragment>
                          <MDBCard>
                            <MDBCardHeader>Customer Details</MDBCardHeader>
                            <MDBCardBody>
                              {rowData.code === "0" ? (
                                <>
                                  <h5 className="h5-responsive red-text">
                                    <FontAwesomeIcon icon={faWarning} /> EDITING
                                    IS NOT ALLOWED
                                  </h5>
                                </>
                              ) : (
                                <>
                                  <AddEditCustomer
                                    deployURL={props.deployURL}
                                    apiServer={props.apiServer}
                                    code={rowData.code}
                                    apiServerHybrid={props.apiServerHybrid}
                                    toggleModal={toggleAddEdit}
                                    refreshGrid={refreshGrid}
                                    toggleModal2={props.toggleModal2}
                                    quickadd="no"
                                  />
                                </>
                              )}
                            </MDBCardBody>
                          </MDBCard>
                        </React.Fragment>
                      );
                    },
                  },
                ]}
              />
            </React.Fragment>
          )}
        </MDBCol>
      </MDBRow>

      <MDBModal
        backdrop={false}
        isOpen={modalAddEdit}
        toggleModal={toggleAddEdit}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBCard>
          <MDBCardHeader className="primary-color">
            <h5 className="h5-responsive white-text">
              <b>Add New Customer</b>
            </h5>
          </MDBCardHeader>
          <MDBCardBody>
            <AddEditCustomer
              deployURL={props.deployURL}
              apiServer={props.apiServer}
              code={""}
              apiServerHybrid={props.apiServerHybrid}
              toggleModal={toggleAddEdit}
              refreshGrid={refreshGrid}
              toggleModal2={props.toggleModal2}
              quickadd="yes"
            />
          </MDBCardBody>
        </MDBCard>

        {/* <AddEditDirectiveDetails toggleModal={toggleAddEdit} code={"newrecord"} directivecode={props.code}  apiServer={props.apiServer} loadDirectivesMain={props.loadDirectivesMain}/> */}
      </MDBModal>

      {/*    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    /> */}
    </React.Fragment>
  );
};

export default Customer;
